import React, { useContext } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Avatar,
  CircularProgress
} from '@mui/material';
import { ChatContext } from '../../contexts/ChatContext';
import OnlineStatusDot from './OnlineStatusDot';

// Status labels for display
const STATUS_LABELS = {
  online: 'Online',
  away: 'Abwesend',
  offline: 'Offline'
};

const UserList = () => {
  const { allUsers, getUserStatus, startConversation, setActiveConversation } = useContext(ChatContext);

  const handleUserClick = async (userId) => {
    const conv = await startConversation(userId);
    if (conv) {
      setActiveConversation(conv);
    }
  };

  if (allUsers.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  return (
    <List sx={{ width: '100%', p: 0 }}>
      {allUsers.map((user) => {
        const status = getUserStatus(user.id);
        return (
          <ListItem key={user.id} disablePadding>
            <ListItemButton onClick={() => handleUserClick(user.id)}>
              <ListItemAvatar>
                <Box sx={{ position: 'relative' }}>
                  <Avatar sx={{ bgcolor: 'primary.main' }}>
                    {(user.full_name || user.username).charAt(0).toUpperCase()}
                  </Avatar>
                  <Box sx={{ position: 'absolute', bottom: 0, right: 0 }}>
                    <OnlineStatusDot
                      status={status}
                      lastSeenAt={user.last_seen_at}
                      size={12}
                    />
                  </Box>
                </Box>
              </ListItemAvatar>
              <ListItemText
                primary={user.full_name || user.username}
                secondary={STATUS_LABELS[status] || 'Offline'}
                primaryTypographyProps={{ fontWeight: 500 }}
              />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
};

export default UserList;
